import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage, localePath } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

const LanguageToggle = () => {
  const { language, basePath } = useLanguage();
  const navigate = useNavigate();

  // Switch language by navigating to the same page in the other language.
  const switchLanguage = () => {
    const target = language === 'it' ? 'en' : 'it';
    navigate(localePath(basePath, target));
  };

  return (
    <Button
      onClick={switchLanguage}
      variant="ghost"
      size="sm"
      className="flex items-center gap-2 hover:bg-gray-100 transition-colors"
      title={language === 'it' ? 'Switch to English' : 'Passa all\'Italiano'}
    >
      <Globe className="w-4 h-4" />
      <div className="flex items-center gap-1 font-semibold">
        <span className={`${language === 'it' ? 'text-gray-900' : 'text-gray-400'}`}>IT</span>
        <span className="text-gray-400">/</span>
        <span className={`${language === 'en' ? 'text-gray-900' : 'text-gray-400'}`}>EN</span>
      </div>
    </Button>
  );
};

export default LanguageToggle;
